module.exports = {
  '菜单': '菜單',
  '首页': '首頁',
  '贡献': '貢獻',
  '理财': '理財',
  '资产': '資產',
  '我的社群': '我的社群',
  '分红节点': '分紅節點',
  '邀请好友': '邀請好友',
  '制度说明': '制度說明',
  '复制成功': '複製成功',
  '复制失败': '複製失敗',
  '公告列表': '公告列表',
  '公告详情': '公告詳情',
  '没有更多了': '沒有更多了',
  '流通量': '流通量',
  '总发行量': '總發行量',
  '低池U量': '底池U量',
  '低池ACT量': '底池ACT量',
  '当前分红节点：': '當前分紅節點：',
  'ACT币趋势': 'ACT幣趨勢',
  '当前价格': '當前價格',
  '选择支付方式': '選擇支付方式',
  '我的贡献': '我的貢獻',
  '确定': '確定',
  '应支付': '應支付',
  '请输入贡献数量': '請輸入貢獻數量',
  '请输入交易密码': '請輸入交易密碼',
  '贡献数量': '貢獻數量',
  '交易密码': '交易密碼',
  '复投': '復投',
  '复投成功': '復投成功',
  'USDT+卡牌': 'USDT+卡牌',
  'ACT+卡牌': 'ACT+卡牌',
  '可用': '可用',
  '请输入数量': '請輸入數量',
  '请输入复投数量': '請輸入復投數量',
  '请勿重复提交': '請勿重複提交',
  '我的理财': '我的理財',
  '参与理财': '參與理財',
  '价格': '價格',
  '收益率': '收益率',
  '天': '天',
  '到账地址': '到賬地址',
  '理财收益率': '理財收益率',
  '理财金额': '理財金額',
  '周期': '週期',
  '到期': '到期',
  '当期收益': '當期收益',
  '已结束': '已結束',
  '理财中': '理財中',
  '参与成功': '參與成功',
  '卡牌': '卡牌',
  '互转': '互轉',
  '闪兑': '閃兌',
  '提现': '提現',
  '互转记录': '互轉記錄',
  '闪兑记录': '閃兌記錄',
  '提现记录': '提現記錄',
  '手续费': '手續費',
  '提现地址': '提現地址',
  '兑换方式': '兌換方式',
  '转账地址': '轉賬地址',
  '时间': '時間',
  'ACT兑卡牌': 'ACT兌卡牌',
  'ACT兑USDT': 'ACT兌USDT',
  'USDT兑ACT': 'USDT兌ACT',
  '钱包': '錢包',
  '操作时间': '操作時間',
  '流水明细': '流水明細',
  '请输入接收地址': '請輸入接收地址',
  '请输入互转数量': '請輸入互轉數量',
  '互转数量': '互轉數量',
  '互转说明': '互轉說明',
  '接收地址': '接收地址',
  '实际到账': '實際到賬',
  '互转成功': '互轉成功',
  '自动计算': '自動計算',
  '闪兑说明': '閃兌說明',
  '实际销毁': '實際銷毀',
  '闪兑数量': '閃兌數量',
  '闪兑币种': '閃兌幣種',
  '请输入闪兑数量': '請輸入閃兌數量',
  '操作成功': '操作成功',
  '提现数量': '提現數量',
  '最小提现数量': '最小提現數量',
  '请输入提现地址': '請輸入提現地址',
  '提现说明': '提現說明',
  '请输入提现数量': '請輸入提現數量',
  '账号': '帳號',
  '贡献值': '貢獻值',
  '我的推荐': '我的推薦',
  '节点团队业绩': '節點團隊業績',
  '理财团队一月内业绩': '理財團隊一個月內業績',
  '理财团队一月以上业绩': '理財團隊一個月以上業績',
  '直推人数': '直推人數',
  '级别': '級別',
  '分红点': '分紅點',
  '团队人数': '團隊人數',
  '权益值': '權益值',
  '推广链接': '推廣連結',
  '当前系统分红节点': '當前系統分紅節點',
  '我的节点': '我的節點',
  '节点记录': '節點記錄',
  '节点数量': '節點數量',
  '节点排名': '節點排名',
  '名次': '名次',
  '数量': '數量',
  'DAB数量': 'DAB數量',
  '地址': '地址',
  '是否有效': '是否有效',
  '有效节点': '有效節點',
  '无效节点': '無效節點',
  '兑换时间': '兌換時間',
  '复制并保存': '複製並保存',
  '到期收益': '到期收益',
  '复制链接': '複製連結',
  '消耗数量': '消耗數量',
  '待审核': '待審核',
  '通过': '通過',
  '驳回': '駁回',
  '转账中': '轉賬中',
  '驳回原因': '駁回原因',
  '充值说明': '充值說明',
  '充值数量': '充值數量',
  '请输入充值数量': '請輸入充值數量',
  '充值': '充值',
  '请确认新密码': '請確認新密碼',
  '请输入新密码': '請輸入新密碼',
  '请输入旧密码': '請輸入舊密碼',
  '修改密码': '修改密碼',
  '支付': '支付',
  '支付数量': '支付數量',
  '支付币种': '支付幣種',
  '实际支付': '實際支付',
  '来源地址': '來源地址',
  '成功': '成功',
  '检测中': '檢測中',
  '充值地址': '充值地址',
  '充值记录': '充值記錄',
  '失败': '失敗',
  '余额不足': '餘額不足',

  "矿机": "礦機",
  "我的矿机": "我的礦機",
  "已购买矿机": "已購買礦機",
  "台": "台",
  "开始挖矿": "開始挖礦",
  "进度": "進度",
  "动态分红": "動態分紅",
  "查看更多": "查看更多",
  "领导分红": "領導分紅",
  "提示": "提示",
  "取消": "取消",
  "请先购买矿机": "請先購買礦機",
  "矿机商城": "礦機商城",
  "价值": "價值",
  "购买": "購買",
  "购买次数": "購買次數",
  "过期矿机": "過期礦機",
  "运行次数": "運行次數",
  "购买日期": "購買日期",
  "到期日期": "到期日期",
  "已过期": "已過期",
  "产出": "產出",
  "USDT兑ACTs": "USDT兌ACTs",
  "冻结": "凍結",
  "启动": "啟動",
  "运行中": "運行中",
  "暂无收汇地址": "暫無收匯地址",
  "钱包提现": "錢包提現",
  "银行卡提现": "銀行卡提現",
  "人民币": "人民幣",
  "美金": "美金",
  "英镑": "英鎊",
  "欧元": "歐元",
  "聊天": "聊天",
  "请先维护提现银行卡信息": "請先維護提現銀行卡資訊",
  "身份输入": "身份輸入",
  "身份信息": "身份資訊",
  "姓名": "姓名",
  "请输入姓名": "請輸入姓名",
  "姓拼音": "姓拼音",
  "请输入姓拼音, 如`Zhang`": "請輸入姓拼音，如`Zhang`",
  "请输入姓拼音": "請輸入姓拼音",
  "名拼音": "名拼音",
  "请输入名拼音, 如`San`": "請輸入名拼音，如`San`",
  "请输入名拼音": "請輸入名拼音",
  "证件信息": "證件資訊",
  "国籍": "國籍",
  "证件类型": "證件類型",
  "证件号": "證件號",
  "请输入证件号": "請輸入證件號",
  "银行卡信息": "銀行卡資訊",
  "银行名称": "銀行名稱",
  "请输入银行名称": "請輸入銀行名稱",
  "银行卡号": "銀行卡號",
  "请输入银行卡号": "請輸入銀行卡號",
  "开户行": "開戶行",
  "请输入开户行": "請輸入開戶行",
  "中华人民共和国": "中華人民共和國",
  "美国": "美國",
  "英国": "英國",
  "户口本": "戶口本",
  "护照": "護照",
  "请上传银行卡照片（选填）": "請上傳銀行卡照片（選填）",
  "去添加": "去新增",
  "完善信息": "完善資訊",
  "邀请人": "邀請人",
  "请输入邀请码": "請輸入邀請碼",
  "请输入6位纯数字": "請輸入6位純數字",
  "请复制聊天链接，在手机默认浏览器中打开使用！": "請複製聊天連結，在手機預設瀏覽器中開啟使用！",
  "复制": "複製",
  "语音聊天": "語音聊天",
  "已收益": "已收益",
  "每日收益": "每日收益",
  "我的理财明细": "我的理財明細",
  "币种": "幣種",
  "类型": "類型",
  "理财收益": "理財收益",
  "理财记录": "理財記錄",
  "请切换币安链": "請切換幣安鏈",
  "充值中，请不要返回！": "充值中，請不要返回！",
  "提现未开启": "提現未開啟",

  "收货地址": "收貨地址",
  "新增地址": "新增地址",
  "编辑": "編輯",
  "删除": "刪除",
  "默认": "預設",
  "保存": "儲存",
  "请输入收货人姓名": "請輸入收貨人姓名",
  "收货人": "收貨人",
  "请输入收货人手机号": "請輸入收貨人手機號",
  "手机号": "手機號",
  "所在地区": "所在地區",
  "请选择地区": "請選擇地區",
  "请输入详细地址：如道路、街道、楼号等": "請輸入詳細地址：如道路、街道、樓號等",
  "设为默认收货地址": "設為預設收貨地址",
  "编辑地址": "編輯地址",
  "确定要删除此地址吗?": "確定要刪除此地址嗎？",

  "修改地址成功": "修改地址成功",
  "添加地址成功": "新增地址成功",
  "删除成功": "刪除成功",

  "提交订单": "提交訂單",
  "提交": "提交",
  "品鉴商城": "品鑑商城",

  "快递公司": "快遞公司",
  "快递单号": "快遞單號",

  "我的订单": "我的訂單",
  "我的收益": "我的收益",
  "过期收益": "過期收益",
  "选择这个地址": "選擇這個地址",
  "请选择您的地区": "請選擇您的地區",
  "支付失败": "支付失敗",

  "请选择语言": "請選擇語言",
  "行情": "行情",
  "我的团队": "我的團隊",
  "交易规则": "交易規則",
  "关于我们": "關於我們",
  "公告中心": "公告中心",

  "今日分红": "今日分紅",
  "算力值": "算力值",
  "投资数量": "投資數量",
  "投资倍数": "投資倍數",
  "兑换": "兌換",
  "用户": "用戶",
  "金额": "金額",

  "我的钱包": "我的錢包",
  "请先从左上角连接钱包": "請先從左上角連接錢包",
  "确定要退出吗": "確定要退出嗎",

  "我的钱包地址": "我的錢包地址",
  "上级钱包地址": "上級錢包地址",
  "累计收益": "累計收益",
  "我的算力": "我的算力",
  "总算力": "總算力",

  "可用数量": "可用數量",
  "提现范围": "提現範圍",
  "提现时间": "提現時間",

  "成交量": "成交量",
  "矿工数": "礦工數",

  "请安装钱包插件": "請安裝錢包插件",
  "请手动切换到币安链": "請手動切換至幣安鏈",
  "用户取消连接": "用戶取消連接",
  "签名被取消": "簽名被取消",
  "登录失败": "登入失敗",

  "团队业绩": "團隊業績",
  "算力": "算力",
  "设置等级": "設置等級",
  "确定要设置等级吗": "確定要設置等級嗎",

  "级别": "級别",
  "确定要设置级别吗": "確定要設置級别嗎",

  "个人算力": "個人算力",
  '会员等级': '會員等級',
  '投资记录': '投資記錄',
  '投资': '投資',
  '直推列表': '直推列表',
  '请输入账号': '請輸入賬號',
  '直推有效人数': '直推有效人數',
  '搜索': "搜索",
  '全网总算力': '全網總算力',
  '显示团队': '顯示團隊',
  '显示直推': '顯示直推',
  '您要绑定的邀请码': '您要綁定的邀請碼',
  '您需要有绑定的邀请码': '您需要有綁定的邀請碼',
  '全部': '全部',
  '累计分红': '累計分紅',

};